<template>
  <button type="button" :class="{
    'btn': true,
    'btn-primary': !(saving || !hasChanged),
    'btn-link': saving || !hasChanged
  }" :disabled="saving || !hasChanged" @click="click">
    <span v-if="saving && clicked">{{savingText}}</span>
    <span v-else-if="!saving && hasChanged">{{saveText}}</span>
    <span v-else class="span-flex-center">
      <IconCheck height="18" class="no-primary match-icon-color mr-1" />
      <span>{{savedText}}</span>
    </span>
  </button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    hasChanged: Boolean,
    savingText: {
      type: String,
      default: 'Saving...'
    },
    saveText: {
      type: String,
      default: 'Save'
    },
    savedText: {
      type: String,
      default: 'No unsaved changes'
    }
  },
  computed: mapState([ 'saving' ]),
  methods: {
    click: function () {
      this.clicked = true
      this.$emit('click')
    }
  },
  data: function () {
    return {
      clicked: false
    }
  },
  watch: {
    saving: function (newVal, oldVal) {
      if (newVal === false) {
        this.clicked = false
      }
    }
  }
}
</script>
